<div class="main-padding mt-5 mb-5">
  <div class="row">
    <div class="col-lg-3 mb-3 content--left">
      <div class="my-calendar">
        <app-my-calendar-events
          [date]="dateSelected"
          [events]="myEvents"
          (dayClicked)="handleDayClicked($event)"
        ></app-my-calendar-events>
      </div>
      <!-- TODO: enable when sync and download is supported by BE -->
      <!-- <app-collapsible-light
        title="Synchronize or download"
        [expanded]="openStates.sync"
      >
        <app-my-calendar-sync
          hiddenContent
          [syncOptions]="syncOptions"
          [syncSystemOptions]="syncSystemOptions"
        ></app-my-calendar-sync>
      </app-collapsible-light> -->

      <!-- TODO: enable when preferences BE -->
      <!-- <div class="my-preferences">
        <app-collapsible-light title="Preferences" [expanded]="openStates.sync">
        </app-collapsible-light>
      </div> -->

      <app-collapsible-light title="Show" [expanded]="openStates.showOptions">
        <app-my-calendar-show-options
          hiddenContent
          (myCalendarShowOptionsChanged)="myCalendarShowOptionsChanged($event)"
          [showOptions]="showOptions"
        ></app-my-calendar-show-options>
      </app-collapsible-light>
    </div>
    <div class="col-lg-9">
      <div class="col-12 pt-3 my-events">
        <div class="row">
          <div class="col-md-5">
            <app-event-list
              [showActiveEventInline]="showActiveEventInline"
              [activeEventId]="selectedEvent?.event_id ?? null"
              [events]="myEventsFiltered"
              [selectedDate]="dateSelected"
              [useDatesMarker]="true"
              (eventClicked)="selectEvent($event)"
              (goToEventPageClicked)="selectEvent($event)"
            ></app-event-list>
          </div>
          <div class="col-md-7" *ngIf="!showActiveEventInline">
            <app-event
              *ngIf="selectedEvent"
              [event]="selectedEvent"
              [inline]="true"
              [minified]="false"
              class="event"
            ></app-event>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
